// extracted by mini-css-extract-plugin
module.exports = {"container":"BL-z","links":"CL-z"};